export const executiveSummaryStrings = {
  en: {
    executiveSummaryMenu: 'Executive Summary',
    executiveSummaryTitle: 'Executive Summary',
    capacityMetrics: 'Capacity Metrics',
    allocationType: 'Allocation Type',
    primarySkills: 'Primary Skills',
    secondarySkills: 'Secondary Skills',
    seniority: 'Seniority',
    isBillable: 'Is Billable',
    dateRange: 'Date Range',
    reset: 'Reset',
    apply: 'Apply',
    companyStrength: 'Company Strength',
    employees: 'Employees',
    totalCalendarDays: 'Total Calendar Days',
    workingDays: 'Working Days',
    standardWorkHours: 'Standard Work Hours',
    hrsPerDay: 'hrs/day',
    totalCapacity: 'Total Capacity',
    netAvailableCapacity: 'Net Available Capacity',
    totalAllocated: 'Total Allocated',
    totalUnallocated: 'Total Unallocated',
    overallocated: 'Overallocated',
    holidayImpact: 'Holiday Impact',
    leaveImpact: 'Leave Impact',
    hours: 'Hours',
    days: 'Days',
    allocationEfficiency: 'Allocation Efficiency',
    allocationEfficiencyFormula:
      'Allocation Efficiency = Allocated / Net Capacity',
    allocationEfficiencyFooter:
      '{allocated} hrs allocated out of {net} hrs net capacity.',
    externalVsInternal: 'External vs Internal Allocation',
    leaveAndTimeImpact: 'Leave & Time Impact',
    externalClient: 'External (Client Work)',
    internalAdmin: 'Internal (Admin/Bench/R&D)',
    allocationBandDistribution: 'Allocation Band Distribution',
    leaveImpactDays: 'Leave Impact',
    holidayImpactDays: 'Holiday Impact',
    fullyLeaveCovered: 'Fully Leave Covered',
    timeLost: 'Time Lost',
    noDataAvailable: 'No Data Available',
    selectAtLeastOneAllocationType: 'Select at least one allocation type',
    dateRangeOrder: 'End date must be on or after start date',
    dateRangeMax: 'Date range cannot exceed {maxDays} days',
    all: 'All',
    billable: 'Billable',
    nonBillable: 'Non-Billable',
    yes: 'Yes',
    no: 'No',
    selectedCount: '{n} Selected'
  }
}
